<template>
    <v-container fluid>
        <v-layout justify-center>
            <v-flex md8>
              <DataTableMain :datatable="table" :on-success="successAction" :itemsAction="tableAction"/>
            </v-flex>
        </v-layout>
        <MainFormDialog v-if="get_dialogMain.dialog" :fields="form" :model="object" :urls="url" :message="message" />

    </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import DataTableMain from '@/components/tables/DataTableMain'
import MainFormDialog from '@/components/dialogs/MainFormDialog'

export default {
  data: () => ({
    table: {
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre', hidden: '' }
        ],
        titles: [
          { text: 'Cve Plantel', value: 'clave', class: 'black--text' },
          { text: 'Nombre Plantel', value: 'nombre', class: 'black--text' },
          { text: 'Activo', value: 'Activo', class: 'black--text' },
          { text: '', value: 'ActionsLocal', class: 'black--text' }
        ],
        loading: false
      },
      body: {
        data: [],
        actions: []
      },
      footer: {
        paging: true
      }
    },
    user: {},
    form: [],
    object: {},
    url: {},
    message: ''
  }),
  components: {
    DataTableMain,
    MainFormDialog
    /*
    UsersDialog,
    AssifnRoleToUserDialog,
    UpdatePasswordUserDialog
    */
  },
  mounted () {
    this.getUrl('POST/config/departamentos/show')
  },
  methods: {
    successAction (item) {
      this[item.action](item)
    },
    refreshData (item) {
      this.table.header.loading = true
      this.getUrl('POST/config/departamentos/show')
    },
    newData (item) {
      this.form = this.get_usersForm
      this.object = {}
      this.url = this.get_urls['POST/config/auth/usuarios/store']
      this.message = 'Registro Agregado Correctamente'
      this.SHOW_DIALOG_MAIN({ type: 'create', with: 500, title: 'Nuevo Usuario' })
    },
    /* ========== ========== ========== ========== ========== */
    tableAction (item) {
      this[item.action](item)
    },
    toAssignRole (item) {
      this.form = this.get_assignRoles
      this.object = {
        id: item.item.id,
        usuario: item.item.usuario,
        NombreCompleto: item.item.empleado.NombreCompleto,
        roles: item.item.roles
      }
      this.url = this.get_urls['POST/config/auth/usuarios/assign-rol']
      this.message = 'Registro Agregado Correctamente'
      this.SHOW_DIALOG_MAIN({ type: 'create', with: 550, title: 'Asignar Rol - Usuario' })
    },
    toEditData (item) {
      this.user = item.item
      this.SHOW_DIALOG_MAIN({ type: 'update', with: 500, title: 'Editar Usuario' })
    },
    /*
    toUpdatePassword (item) {
      this.user = item.item
      this.SHOW_DIALOG_SECOUND_MAIN({ type: 'create', showtype: 'password' })
    },
    toMunicipiosAssign (item) {
      this.SET_DATA_SECOUND_MAIN(item.item)
      router.push({ name: 'ViewMunicipiosRoleAssign', params: { id: item.item.id } })
    },
    */
    ...mapActions(['getUrlServices', 'postServiceListAction']),
    getUrl (objet) {
      if (this.get_urls != null) {
        const router = this.get_urls[objet]
        this.postServiceListAction({ url: router, data: {} })
      } else {
        this.getUrlServices()
      }
    },
    ...mapMutations(['SHOW_DIALOG_MAIN', 'SHOW_DIALOG_SECOUND_MAIN', 'CLEAR_DATA_LIST', 'SET_DATA_SECOUND_MAIN'])
  },
  computed: {
    ...mapGetters(['get_urls', 'get_objects', 'get_dialogMain', 'get_usersForm', 'get_assignRoles'])
  },
  watch: {
    get_urls () {
      this.getUrl('POST/config/departamentos/show')
    },
    get_objects (vals) {
      if (vals) {
        this.table.header.loading = false
        this.table.body.data = vals
      }
    }
  },
  beforeDestroy () {
    this.CLEAR_DATA_LIST()
  }

}
</script>

<style>

</style>
crear curd de roles
